import { render, staticRenderFns } from "./PhotowallEditTabAccount.vue?vue&type=template&id=6e72488a&"
import script from "./PhotowallEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./PhotowallEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./PhotowallEditTabAccount.vue?vue&type=style&index=0&id=6e72488a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports